"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiatMarketProviders = void 0;
const exchange_rates_host_1 = require("./exchange-rates-host/exchange-rates-host");
// Order of this FiatMarketProviders array constitutes the order of providers we will be checking first.
// More reliable providers should be listed first.
exports.FiatMarketProviders = [new exchange_rates_host_1.ExchangeRateHostService()];
